import { Box, Typography } from "@mui/material";
import { colors } from "../../../../theme/palette";

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "flex-start",
      columnGap: "10px",
      marginBottom: "25px",
    }}
  >
    <Icon style={{ fill: "none" }} />
    <Typography variant="h5Bold" sx={{ color: colors.black, fontSize: "20px", fontWeight: "700" }}>
      {title}
    </Typography>
  </Box>
);

export default SectionHeader;
